import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const AddIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M18.98 11.03h-6v-6a1 1 0 0 0-.98-.98 1 1 0 0 0-.97.98v6h-6a1 1 0 0 0-.98.97 1 1 0 0 0 .97.97h6v6a1 1 0 0 0 .98.98 1 1 0 0 0 .97-.97v-6h6a1 1 0 0 0 .98-.98.95.95 0 0 0-.97-.97Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default AddIcon;
